import React from 'react';
import Fade from '@material-ui/core/Fade/Fade';
import withStyles from '@material-ui/core/styles/withStyles';
import { LoaderIcon } from './Loader';

const styles = () => ({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    zIndex: 2,
    backgroundColor: 'rgba(255,255,255,0.3)',
  },
  inner: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column',
    display: 'flex',
  },
});

export default withStyles(styles, { name: 'Progress' })(({ loading, classes }) => {
  return (
    <Fade
      in={loading}
      timeout={700}
      style={{
        transitionDelay: loading ? '300ms' : '0ms',
      }}
      unmountOnExit
    >
      <div className={classes.container}>
        <div className={classes.inner}>
          <LoaderIcon />
        </div>
      </div>
    </Fade>
  );
});
